export default __webpack_public_path__ + "static/media/Group 4615.7b55215d.svg";